import { useFormikContext } from 'formik';
import { useIntl } from 'react-intl';
import { PERIOD_HOURS_FIELD_MAP } from './useSetResourceAllocationOnChangeHandlers';

const useSetResourceAllocationPeriodError = () => {
  const { formatMessage } = useIntl();
  const {
    errors,
    touched,
    values: { selectedAllocationPeriod }
  } = useFormikContext();

  const activeFieldName = PERIOD_HOURS_FIELD_MAP[selectedAllocationPeriod];

  const allocationError =
    touched[activeFieldName] && errors[activeFieldName]
      ? formatMessage({ id: errors[activeFieldName] })
      : null;

  return { allocationError };
};

export default useSetResourceAllocationPeriodError;
